import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from './auth.service';

/**
 * Solo deja pasar a usuarios con rol OWNER (poder total: Dev Panel).
 *
 * Se usa después de authGuard: si los roles aún no están cargados
 * (recarga de página), consulta /auth/me antes de decidir.
 * @param _route - Ruta destino; no se usa.
 * @param _state - Estado del router; no se usa.
 * @returns `true` si es OWNER, o un `UrlTree` a la raíz si no lo es o si `/auth/me` falla
 *   (directo o como Observable cuando hay que consultar los roles).
 */
export const ownerGuard: CanActivateFn = (_route, _state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.roles().length > 0) {
        return authService.isOwner() || router.createUrlTree(['/']);
    }

    return authService.me().pipe(
        map(() => authService.isOwner() || router.createUrlTree(['/'])),
        catchError(() => of(router.createUrlTree(['/'])))
    );
};
